import React, { Component } from "react";

import CustomStaticLogout from "./CustomStaticLogout.js";




export default class extends Component {
  render() {
    return (
      <div className="asset-detail ">
        {/* <LayoutWrapper> */}
        <CustomStaticLogout />
        {/* </LayoutWrapper> */}
      </div>
    );
  }
}
